module.exports = "../dist/img/white-38.9195.jpg";